import React, { useEffect, useRef } from 'react';
import { Dropdown, useDropdown } from '@vtblife/uikit';

import { AgentFavoritesLikeList } from './AgentFavoritesLikeList/AgentFavoritesLikeList';

interface AgentFavoritesDropdownTriggerArgs {
    handleToggle: VoidFunction;
}

interface AgentFavoritesDropdownProps {
    offerId: string;
    isMyFavorite: boolean;
    renderTrigger: (args: AgentFavoritesDropdownTriggerArgs) => React.ReactNode;
    onChangeMyFavorite: (v: boolean) => void;
}

export const AgentFavoritesDropdown: React.FC<AgentFavoritesDropdownProps> = ({
    offerId,
    isMyFavorite,
    renderTrigger,
    onChangeMyFavorite,
}) => {
    return (
        <Dropdown>
            <CustomControl renderTrigger={renderTrigger} />
            <Dropdown.Content
                placement='local'
                positioning='end'
            >
                <AgentFavoritesLikeList
                    offerId={offerId}
                    isMyFavorite={isMyFavorite}
                    limitHeight
                    onChangeMyFavorite={onChangeMyFavorite}
                />
            </Dropdown.Content>
        </Dropdown>
    );
};

const CustomControl = (props: { renderTrigger: (args: AgentFavoritesDropdownTriggerArgs) => React.ReactNode }) => {
    const { toggle, registerControl } = useDropdown();
    const control = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        registerControl(control.current!);
    }, [ registerControl ]);

    return (
        <span ref={control}>
            {props.renderTrigger({ handleToggle: toggle })}
        </span>
    );
};
